import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CrudService } from 'src/app/core/services/crud.service';
import { fetchSubscribersList, fetchSubscribersListFailure, fetchSubscribersListSuccess } from './subscribers.action';

@Injectable()
export class SubscribersEffects {
  constructor(
    private actions$: Actions,
    private CrudService: CrudService,
  ) {}

  fetchData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSubscribersList),
      mergeMap((action:any) =>
        this.CrudService.fetchData(
          `Admin/GetSubscribers?PageNumber=${action.payload.pageNumber}&PageSize=${action.payload.pageSize}
          &SortColumn=${action.payload.sortColumn}&SortOrder=${action.payload.sortOrder}&Search=${action.payload.search}`).pipe(
          map((result) => fetchSubscribersListSuccess({ response: result })),

          catchError((error) => of(fetchSubscribersListFailure({ error })))
        )
      )
    )
  );

}
